
import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

import CookieBanner from 'react-cookie-banner';

import Link from 'components/Link';
import MainNavigationDropdownHeader from './MainNavigationDropdownHeader';
import MainNavigationItem from './MainNavigationItem';
import MainNavigationSearchBar from './MainNavigationSearchBar';

import * as actions from 'actions';
import { getSearchBar, getChatState, getUserProfile, getChatQueueRejection } from 'selectors';
import './style.scss';

export class MainNavigation extends Component {

  constructor(props) {
    super(props);

    this.handleSearchItemClick = this.handleSearchItemClick.bind(this);
    this.handleSearchBarClose = this.handleSearchBarClose.bind(this);
    this.handleMoreOnTabletClick = this.handleMoreOnTabletClick.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.dropdown.hide();
      this.moreDropdown.hide();
    }
  }

  handleSearchItemClick(event) {
    event.preventDefault();
    this.props.onSearchBarOpen();
  }

  handleSearchBarClose() {
    this.props.onSearchBarClose();
  }

  handleMoreOnTabletClick(event) {
    event.preventDefault();
  }

  handleLogout() {
    this.props.onLogout();
  }

  render() {
    let searchBar = null;

    if(this.props.searchBarVisible) {
      searchBar = <MainNavigationSearchBar onClose={this.handleSearchBarClose} />;
    }

    return (
      <header>
        <nav className="MainNavigation">
          <div className="wrapper-full">
            <div className="user-dropdown show-for-tablet">
              <Dropdown className="show-for-tablet" ref={(c) => this.dropdown = c} >
                <DropdownTrigger>
                  <span className="dropdown-trigger-text">
                    <span className="username">
                      {this.props.userName}
                    </span>
                  </span>
                  <span className="icon-nav-arrow-down"></span>
                </DropdownTrigger>

                <DropdownContent>
                  <div className="dropdown-content-inner">
                    <MainNavigationDropdownHeader />

                    <ul className="user-menu">
                      <li>
                        <a className="Link is-half-opaque" onClick={this.handleLogout}>{__('members.navigation.logout')}</a>
                      </li>
                    </ul>
                  </div>
                </DropdownContent>
              </Dropdown>
            </div>

            <ul>
              <MainNavigationItem onlyActiveOnIndex to="/" type="home" iconUrl={__('logoUrl')} showForTablet />
              <MainNavigationItem onlyActiveOnIndex to="/" type="home" iconUrl={__('members.header.iconFeed')} hideForTablet />
              {(process.env.FEATURES.mail === true || process.env.FEATURES.chat === true) && <MainNavigationItem to="/messages" type="messages" iconUrl={__('members.header.iconMessages')} isOnline={this.props.isChatOnline} isChatEnabled={process.env.FEATURES.chat === true} />}
              {process.env.FEATURES.magazine === true && <MainNavigationItem to="/magazine" type="magazine" iconUrl={__('members.header.iconMagazine')} />}
              {process.env.FEATURES.forums === true && <MainNavigationItem to="/forum" type="forum" iconUrl={__('members.header.iconForum')} />}
              <MainNavigationItem onClick={this.handleSearchItemClick} type="search" iconUrl={__('members.header.iconSearch')} showForTablet />
              <MainNavigationItem to="/more" type="more" iconUrl={__('members.header.iconMore')} hideForTablet />
              <MainNavigationItem onClick={this.handleMoreOnTabletClick} dropdownRef={(c) => this.moreDropdown = c} type="more" iconUrl={__('members.header.iconMore')} showForTablet>
                <ul className="user-menu">
                  <li>
                    <Link to="/goals">{__('members.navigation.goals')}</Link>
                  </li>
                  <li>
                    <Link to="/journal">{__('members.navigation.journal')}</Link>
                  </li>
                  <li>
                    <Link to="/links">{__('members.navigation.links')}</Link>
                  </li>
                  <li>
                    <Link to="/interests">{__('members.navigation.interests')}</Link>
                  </li>
                  <li>
                    <a className="Link" target="_blank" href={`${process.env.KOOTH_UNAUTH_URL}/team.html`}>{__('members.navigation.team')}</a>
                  </li>
                  <li>
                    <Link to="/feedback">{__('members.navigation.feedback')}</Link>
                  </li>
                </ul>
              </MainNavigationItem>
            </ul>

            <ReactCSSTransitionGroup transitionName="search-bar-transition" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
              {searchBar}
            </ReactCSSTransitionGroup>
          </div>
        </nav>
         <CookieBanner
          className="privacy"
          dismissOnScroll={false}
          cookie="user-has-accepted-our-apology"
         >
          {(onAccept) => (
            <div className="react-cookie-banner privacy">
              <p className="cookie-message">
                <p>We've recently been experiencing some technical issues which have affected the Kooth service. We're really sorry if this has meant you've been unable to use Kooth. We've been working hard overnight and the service is back to normal today.</p>
                <p>Please bear with us while we catch up on your messages and get all your posts and goals moderated.</p>
                <p>From the Kooth team</p>
              </p>
              <button className="button-close" onClick={onAccept}>X</button>
            </div>
          )}
         </CookieBanner>
      </header>
    );
  }
}

MainNavigation.propTypes = {
  location: PropTypes.string,
  onSearchBarOpen: PropTypes.func,
  onSearchBarClose: PropTypes.func,
  searchBarVisible: PropTypes.bool,
  isChatOnline: PropTypes.bool,
  userName: PropTypes.string,
  onLogout: PropTypes.func
};

const mapStateToProps = state => {
  const chatQueueRejection = getChatQueueRejection(state);

	return {
		searchBarVisible: getSearchBar(state).visible,
    isChatOnline: getChatState(state).stringValue !== 'OFFLINE' && !chatQueueRejection.isRejected,
    userName: getUserProfile(state).userName
	};
};

const mapDispatchToProps = dispatch => {
  return {
    onSearchBarOpen: () => {
      dispatch(actions.searchShow());
    },
    onSearchBarClose: () => {
      dispatch(actions.searchHide());
    },
    onLogout: () => {
      dispatch(actions.authLogout());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainNavigation);



/** WEBPACK FOOTER **
 ** ./src/members/Main/MainNavigation/index.js
 **/